import { Component } from '@angular/core'
import { ProfileLinkComponent } from './components/profile-link/profile-link.component'
import { HelpLinkComponent } from './components/help-link/help-link.component'
import { ReferLinkComponent } from './components/refer-link/refer-link.component'
import { SettingsLinkComponent } from './components/settings-link/settings-link.component'
import { PeopleLinkComponent } from './components/people-link/people-link.component'
import { LogoLinkComponent } from './components/logo-link/logo-link.component'
import { TooltipModule } from 'primeng/tooltip'
import { HomeLinkComponent } from './components/home-link/home-link.component'
import { MenuLinkComponent } from './components/menu-link/menu-link.component'
import { ToggleButtonModule } from 'primeng/togglebutton'
import { FormsModule } from '@angular/forms'
import { UserService } from '@app/core/_services/user.service'
import { Subject, takeUntil } from 'rxjs'
import { User } from '@app/core/_models'
import { FavoritesLinkComponent } from './components/favorites-link/favorites-link.component'
import { ScheduleLinkComponent } from './components/schedule-link/schedule-link.component'
import { ViewportService } from '@app/core/_services/viewport.service'
import { RewardsReferralService } from '@app/core/_services/rewards-referral.service'
import { GroupsLinkComponent } from './components/groups-link/groups-link.component'
import { AdminLinkComponent } from './components/admin-llink/admin-link.component'

@Component({
    selector: 'fm-navigation',
    imports: [
        AdminLinkComponent,
        GroupsLinkComponent,
        ScheduleLinkComponent,
        FavoritesLinkComponent,
        FormsModule,
        ToggleButtonModule,
        MenuLinkComponent,
        HomeLinkComponent,
        TooltipModule,
        LogoLinkComponent,
        ProfileLinkComponent,
        PeopleLinkComponent,
        HelpLinkComponent,
        ReferLinkComponent,
        SettingsLinkComponent,
    ],
    templateUrl: './navigation.component.html',
    styleUrl: './navigation.component.scss',
})
export class NavigationComponent {
    private ngUnsubscribe: Subject<any> = new Subject<any>()
    public emphasizeReferIcon: boolean = false

    public isGroupAdmin: boolean
    public isFmAdmin: boolean
    public gender: number
    constructor(
        public viewportService: ViewportService,
        private userService: UserService,
        private rewardsReferralService: RewardsReferralService,
    ) {}

    ngOnInit() {
        this.userService.currentUser.pipe(takeUntil(this.ngUnsubscribe)).subscribe((user: User) => {
            this.isFmAdmin = user.fmAd
            this.isGroupAdmin = user.group.some((g) => g.groupAdmin === true)
            this.gender = user.genderSelection
        })

        this.rewardsReferralService.emphasizeReferIconSubject
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((emphasize) => {
                if (emphasize) {
                    this.emphasizeReferIcon = true
                }
            })
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next(null)
        this.ngUnsubscribe.complete()
    }
}
